<template>
  <div class="content">
    <h3 ref="pageHeader" :style="{ '--width': widthVar }" class="pageHeader">{{ $store.state.themeTitle }}获奖情况</h3>
    <div>
      <el-form :inline="true" :model="formInline" class="demo-form-inline" label-position="left">
        <el-form-item label="组织结构">
          <OrganDialog ref="organDia1" @getSelect="getSelect1" :level="levell" @handleOrganQuery="handleOrganQuery1">
          </OrganDialog>
          <el-input v-model="organLabel" placeholder="请输入组织结构" style="width:320px;" @focus="dialogOpen1"
            @clear="handeleClear1" clearable></el-input>
        </el-form-item>
        <el-form-item :label="`所属${$store.state.themeTitle}室`">
          <el-select v-model="formInline.training_name" clearable filterable
            :placeholder="`请输入所属${$store.state.themeTitle}室`">
            <el-option v-for="item in $store.state.trainRooms" :key="item.id" :label="item.training_name"
              :value="item.training_name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleQuery">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleAdd()">新增</el-button>
        </el-form-item>
        <!-- <el-form-item>
          <el-button type="primary" @click="handleExport">{{exportTitle}}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handlePrint">打印</el-button>
        </el-form-item> -->
      </el-form>
    </div>
    <div>
      <custom-table :data="tableData" ref="table" border style="width: 100%">
        <custom-table-column fixed prop="training_name" :label="`${$store.state.themeTitle}室名称`" width="160">
        </custom-table-column>
        <custom-table-column prop="teacher_achievement_country" label="教师获奖与成果（国家级）" min-width="220">
        </custom-table-column>
        <custom-table-column prop="teacher_achievement_province" label="教师获奖与成果（省部级）" min-width="220">
        </custom-table-column>
        <custom-table-column prop="teacher_patent" label="教师获奖与成果（发明专利）" min-width="220">
        </custom-table-column>
        <custom-table-column prop="student_awards" label="学生获奖情况" min-width="220">
        </custom-table-column>
        <custom-table-column prop="teach_paper_search" label="教学方面论文和教材情况（三大检索收录）" min-width="220">
        </custom-table-column>
        <custom-table-column prop="research_paper_search" label="科研方面论文和教材情况（三大检索收录）" min-width="220">
        </custom-table-column>
        <custom-table-column prop="teach_paper_publication" label="教学方面论文和教材情况（核心刊物）" min-width="220">
        </custom-table-column>
        <custom-table-column prop="research_paper_publication" label="科研方面论文和教材情况（核心刊物）" min-width="220">
        </custom-table-column>
        <custom-table-column prop="paper_teaching_material" label="论文和教材情况（实验教材）" min-width="220">
        </custom-table-column>
        <custom-table-column prop="scientific_research_project_number_province" label="科研及社会服务情况中科研项目数（省部级以上）"
          width="180">
        </custom-table-column>
        <custom-table-column prop="scientific_research_project_number_other" label="科研及社会服务情况中科研项目数（其它）" width="180">
        </custom-table-column>
        <custom-table-column prop="scientific_research_project_number_social" label="科研及社会服务情况中社会服务项目数" width="180">
        </custom-table-column>
        <custom-table-column prop="scientific_teaching_project_number_province" label="科研及社会服务情况中教研项目数（省部级以上）"
          width="180">
        </custom-table-column>
        <custom-table-column prop="scientific_teaching_project_number_other" label="科研及社会服务情况中教研项目数（其它）" width="180">
        </custom-table-column>
        <custom-table-column prop="graduation_project_paper_number_college" label="毕业设计和论文人数（专科生人数）" width="180">
        </custom-table-column>
        <custom-table-column prop="graduation_project_paper_number_undergraduate" label="毕业设计和论文人数（本科生人数）" width="180">
        </custom-table-column>
        <custom-table-column prop="graduation_project_paper_number_postgraduate" label="毕业设计和论文人数（研究生人数）" width="180">
        </custom-table-column>
        <custom-table-column fixed="right" label="操作" width="120">
          <template slot-scope="scope">
            <el-button @click="handleEdit(scope.row)" type="text" size="small">编辑</el-button>
            <el-button @click="handleDelet(scope.row.id)" type="text" size="small">删除</el-button>
          </template>
        </custom-table-column>
      </custom-table>
      <div class="pageLine">
        <PageLine :total='total' ref="pageChild" @getList="getList"></PageLine>
      </div>
    </div>
    <el-dialog :close-on-click-modal="false" :title="title" :visible.sync="centerDialogVisible" width="806px">
      <!-- <OrganDialog ref="organDia" @getSelect="getSelect" @handleOrganQuery="handleOrganQuery"></OrganDialog> -->
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="160px" class="demo-ruleForm">
        <el-form-item :label="`${$store.state.themeTitle}室`" prop="training_room_id">
          <el-select v-model="ruleForm.training_room_id" filterable style="width:216px;"
            :placeholder="`请输入${$store.state.themeTitle}室`" @change="handleClassChange">
            <el-option v-for="item in $store.state.trainRooms" :key="item.id" :label="item.training_name"
              :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="组织结构" prop="class_name">
          <el-input v-model="selectName" placeholder="请输入组织结构" style="width:532px;" @focus="dialogOpen" @clear="handeleClear" clearable></el-input>
        </el-form-item> -->
        <el-form-item label="教师获奖与成果（国家级）" prop="teacher_achievement_country">
          <!-- <el-input type="textarea" v-model="ruleForm.teacher_achievement_country" :rows="4" style="width:552px;"></el-input> -->
          <el-input v-model.number="ruleForm.teacher_achievement_country" placeholder="请输入"
            style="width:216px;"></el-input>

        </el-form-item>
        <el-form-item label="教师获奖与成果（省部级）" prop="teacher_achievement_province">
          <!-- <el-input type="textarea" v-model="ruleForm.teacher_achievement_province" :rows="4" style="width:552px;"></el-input> -->
          <el-input v-model.number="ruleForm.teacher_achievement_province" placeholder="请输入"
            style="width:216px;"></el-input>

        </el-form-item>
        <el-form-item label="教师获奖与成果（发明专利）" prop="teacher_patent">
          <!-- <el-input type="textarea" v-model="ruleForm.teacher_patent" :rows="4" style="width:552px;"></el-input> -->
          <el-input v-model.number="ruleForm.teacher_patent" placeholder="请输入"
            style="width:216px;"></el-input>

        </el-form-item>
        <el-form-item label="学生获奖情况" prop="student_awards">
          <!-- <el-input type="textarea" v-model="ruleForm.student_awards" :rows="4" style="width:552px;"></el-input> -->
          <el-input v-model.number="ruleForm.student_awards" placeholder="请输入"
            style="width:216px;"></el-input>

        </el-form-item>
        <el-form-item label="教学方面论文和教材情况（三大检索收录）" prop="teach_paper_search">
          <!-- <el-input type="textarea" v-model="ruleForm.teach_paper_search" :rows="4" style="width:552px;"></el-input> -->
          <el-input v-model.number="ruleForm.teach_paper_search" placeholder="请输入"
            style="width:216px;"></el-input>

        </el-form-item>
        <el-form-item label="科研方面论文和教材情况（三大检索收录）" prop="research_paper_search">
          <!-- <el-input type="textarea" v-model="ruleForm.research_paper_search" :rows="4" style="width:552px;"></el-input> -->
          <el-input v-model.number="ruleForm.research_paper_search" placeholder="请输入"
            style="width:216px;"></el-input>

        </el-form-item>
        <el-form-item label="教学方面论文和教材情况（核心刊物）" prop="teach_paper_publication">
          <!-- <el-input type="textarea" v-model="ruleForm.teach_paper_publication" :rows="4" style="width:552px;"></el-input> -->
          <el-input v-model.number="ruleForm.teach_paper_publication" placeholder="请输入"
            style="width:216px;"></el-input>

        </el-form-item>
        <el-form-item label="科研方面论文和教材情况（核心刊物）" prop="research_paper_publication">
          <!-- <el-input type="textarea" v-model="ruleForm.research_paper_publication" :rows="4" style="width:552px;"></el-input> -->
          <el-input v-model.number="ruleForm.research_paper_publication" placeholder="请输入"
            style="width:216px;"></el-input>

        </el-form-item>
        <el-form-item label="论文和教材情况（实验教材）" prop="paper_teaching_material">
          <!-- <el-input type="textarea" v-model="ruleForm.paper_teaching_material" :rows="4" style="width:552px;"></el-input> -->
          <el-input v-model.number="ruleForm.paper_teaching_material" placeholder="请输入"
            style="width:216px;"></el-input>

        </el-form-item>
        <el-form-item label="科研及社会服务情况中科研项目数（省部级以上）" prop="scientific_research_project_number_province">
          <el-input v-model.number="ruleForm.scientific_research_project_number_province" placeholder="请输入"
            style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="科研及社会服务情况中科研项目数（其它）" prop="scientific_research_project_number_other">
          <el-input v-model.number="ruleForm.scientific_research_project_number_other" placeholder="请输入"
            style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="科研及社会服务情况中社会服务项目数" prop="scientific_research_project_number_social">
          <el-input v-model.number="ruleForm.scientific_research_project_number_social" placeholder="请输入"
            style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="科研及社会服务情况中教研项目数（省部级以上）" prop="scientific_teaching_project_number_province">
          <el-input v-model.number="ruleForm.scientific_teaching_project_number_province" placeholder="请输入"
            style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="科研及社会服务情况中教研项目数（其它）" prop="scientific_teaching_project_number_other">
          <el-input v-model.number="ruleForm.scientific_teaching_project_number_other" placeholder="请输入"
            style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="毕业设计和论文人数（专科生人数）" prop="graduation_project_paper_number_college">
          <el-input v-model.number="ruleForm.graduation_project_paper_number_college" placeholder="请输入"
            style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="毕业设计和论文人数（本科生人数）" prop="graduation_project_paper_number_undergraduate">
          <el-input v-model.number="ruleForm.graduation_project_paper_number_undergraduate" placeholder="请输入"
            style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="毕业设计和论文人数（研究生人数）" prop="graduation_project_paper_number_postgraduate">
          <el-input v-model.number="ruleForm.graduation_project_paper_number_postgraduate" placeholder="请输入"
            style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item style="margin-top:8px;width:100%;text-align:right;">
          <el-button type="primary" v-if="type == 'add'" @click="submitForm('ruleForm')">确认</el-button>
          <el-button type="primary" v-if="type == 'edit'" @click="submitForm('ruleForm')">编辑</el-button>
          <el-button @click="resetForm('ruleForm')" style="margin-right:24px;">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" title="提示" :visible.sync="dialogVisible" width="400px">
      <span>是否删除</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="deleteMethod">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mixinList } from '@/assets/js/mixin/list';
import { mixinOrgan } from '@/assets/js/mixin/organization';
// import { mixinFormatter } from '@/assets/js/mixin/formatter';

export default {
  name: 'trainingRoom',
  mixins: [mixinList, mixinOrgan],
  data() {
    return {
      classRooms: [],
      organLabel: '',
      selectName: '',
      formInline: {
        training_name: '',
        status: '',
        structure_1: '',
        structure_2: '',
        course_name: '',
        term: '',
        teacher: ''
      },
      levell: [1, 2],
      loading: false,
      ruleForm: {

        training_room_id: '',
        teacher_achievement_country: 0,
        teacher_achievement_province: 0,
        teacher_patent: 0,
        student_awards: 0,
        teach_paper_search: 0,
        research_paper_search: 0,
        teach_paper_publication: 0,
        research_paper_publication: 0,
        paper_teaching_material: 0,
        scientific_research_project_number_province: 0,
        scientific_research_project_number_other: 0,
        scientific_research_project_number_social: 0,
        scientific_teaching_project_number_province: 0,
        scientific_teaching_project_number_other: 0,
        graduation_project_paper_number_college: 0,
        graduation_project_paper_number_undergraduate: 0,
        graduation_project_paper_number_postgraduate: 0,
      },
      rules: {
        training_room_id: [{ required: true, message: `请选择`, trigger: 'change' }],
        teacher_achievement_country: [{ required: true, message: `请输入`, trigger: 'blur' }, { type: 'number', message: '请填写数字值' }],
        teacher_achievement_province: [{ required: true, message: `请输入`, trigger: 'blur' }, { type: 'number', message: '请填写数字值' }],
        teacher_patent: [{ required: true, message: `请输入`, trigger: 'blur' }, { type: 'number', message: '请填写数字值' }],
        student_awards: [{ required: true, message: `请输入`, trigger: 'blur' }, { type: 'number', message: '请填写数字值' }],
        teach_paper_search: [{ required: true, message: `请输入`, trigger: 'blur' }, { type: 'number', message: '请填写数字值' }],
        research_paper_search: [{ required: true, message: `请输入`, trigger: 'blur' }, { type: 'number', message: '请填写数字值' }],
        teach_paper_publication: [{ required: true, message: `请输入`, trigger: 'blur' }, { type: 'number', message: '请填写数字值' }],
        research_paper_publication: [{ required: true, message: `请输入`, trigger: 'blur' }, { type: 'number', message: '请填写数字值' }],
        paper_teaching_material: [{ required: true, message: `请输入`, trigger: 'blur' }, { type: 'number', message: '请填写数字值' }],
        scientific_research_project_number_province: [{ required: true, message: `请输入`, trigger: 'blur' }, { type: 'number', message: '请填写数字值' },],
        scientific_research_project_number_other: [{ required: true, message: `请输入`, trigger: 'blur' }, { type: 'number', message: '请填写数字值' },],
        scientific_research_project_number_social: [{ required: true, message: `请输入`, trigger: 'blur' }, { type: 'number', message: '请填写数字值' },],
        scientific_teaching_project_number_province: [{ required: true, message: `请输入`, trigger: 'blur' }, { type: 'number', message: '请填写数字值' },],
        scientific_teaching_project_number_other: [{ required: true, message: `请输入`, trigger: 'blur' }, { type: 'number', message: '请填写数字值' },],
        graduation_project_paper_number_college: [{ required: true, message: `请输入`, trigger: 'blur' }, { type: 'number', message: '请填写数字值' },],
        graduation_project_paper_number_undergraduate: [{ required: true, message: `请输入`, trigger: 'blur' }, { type: 'number', message: '请填写数字值' },],
        graduation_project_paper_number_postgraduate: [{ required: true, message: `请输入`, trigger: 'blur' }, { type: 'number', message: '请填写数字值' },],


        // lesson_time: [{ required: true, message: '请输入开始时间', trigger: 'change' }],
        // lesson_end_time: [{ required: true, message: '请输入结束时间', trigger: 'change' }],
      },
      type: 'add',
      tableName: '实训日志',
      users: [],
    };
  },
  created() { },
  mounted() {
    // this.getList();
    this.$store.dispatch('getTarinMent');

    // this.getUsers()
  },
  methods: {
    onSubmit() {
      console.log('submit!');
    },
    handleEdit(row, filterArr = ['updated_at', 'deleted_at', 'created_at', 'login_time']) {
      if (row.structure_1 && row.structure_2 && row.class_name) {
        this.selectName = `${row.structure_1}-${row.structure_2}-${row.class_name}`;
      }
      this.type = 'edit';
      this.title = '编辑';
      this.ruleForm = this.$until.delProp(row, filterArr);
      console.log(this.ruleForm);
      this.centerDialogVisible = true;
    },
    handleInstituteChange(e) {
      this.ruleForm.institute_name = this.$until.getLabelName(this.institutes, 'isid', 'ismc', e);
    },
    getOrganList() {
      if (this.selectNode.level == 3) {
        this.selectName = this.selectNode.structure_names || this.selectNode.name;
        let strArr = this.selectNode.structure_names.split('-');
        this.ruleForm.structure_1 = strArr[0];
        this.ruleForm.structure_2 = strArr[1];
        this.ruleForm.class_name = strArr[2];
      }
      if (!this.selectName) {
        this.ruleForm.structure_1 = '';
        this.ruleForm.structure_2 = '';
        this.ruleForm.class_name = '';
      }
    },
    async getTarinMent() {
      let res = await this.$api.instance.getTarinMent();
      if (res.code == 0) {
        this.classRooms = res.data;
      }
    },
    handleClassChange(e) {
      this.ruleForm.training_name = this.$until.getLabelName(this.$store.state.trainRooms, 'id', 'training_name', e);
    },
    async deleteMethod() {
      let params = { id: this.delid };
      let res = await this.$api.instance.interfaceServer(`api/training/room/awards/destroy/${params.id}`, 'get', {});
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '删除成功！',
        });
        this.dialogVisible = false;
        this.handleQuery();
      }
    },
    async createMethod() {
      let params = this.$until.deleteNullPrototype(this.ruleForm);
      let res = await this.$api.instance.interfaceServer('api/training/room/awards/add', 'post', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '提交成功！',
        });
        this.clearState();
      }
    },
    async updateMethod() {
      let params = this.$until.easyDeepCopy(this.ruleForm);
      let res = await this.$api.instance.interfaceServer('api/training/room/awards/update', 'post', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '编辑成功！',
        });
        this.clearState();
      }
    },
    // resetForm(formName) {
    //   this.$refs[formName].resetFields();
    // },
    submitForm(formName) {
      if (this.ruleForm.lesson_time) {
        this.ruleForm.lesson_time = new Date(this.ruleForm.lesson_time);
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.type == 'add') {
            this.createMethod();
          } else if (this.type == 'edit') {
            this.updateMethod();
          }
        } else {
          // console.log('error submit!!');
          return false;
        }
      });
    },
    handleQuery() {
      this.beforeQueryByKey("query_structure_1", "query_structure_2")
      this.$refs.pageChild.page = 1;
      this.getList();
    },
    async getList() {
      let params = this.$until.deleteNullPrototype(this.formInline);
      params.page = this.$refs.pageChild.page;
      params.size = this.$refs.pageChild.size;
      let res = await this.$api.instance.interfaceServer('api/training/room/awards/list', 'get', params);
      if (res.code == 0 && res.data) {
        this.tableData = res.data.data;
        this.total = res.data.total;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.pageHeader:before {
  width: var(--width);
}

/deep/.el-form-item__label {
  margin-top: 8px;
  line-height: 20px;
}
</style>
